import * as React from 'react';

var _path;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgTagOutline = function SvgTagOutline(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        d: "m13.5 3.677-.75.662.043.045zm6.823 9.823-.662-.75-.045.043zm.177-2.823.75-.662-.043-.045zM10.677 20.5l-.707.707.045.043zm2.646 0 .662.75.045-.043zm-9.646-7 .707-.707-.022-.022-.023-.02zM7 6a1 1 0 0 0 0 2zm.01 2a1 1 0 0 0 0-2zM4 7a3 3 0 0 1 3-3V2a5 5 0 0 0-5 5zm0 5V7H2v5zm3-8h5V2H7zm5 0c.299 0 .566.13.75.339l1.5-1.324A3 3 0 0 0 12 2zm8 8c0 .299-.13.566-.339.75l1.324 1.5A3 3 0 0 0 22 12zm-.25-.661c.156.177.25.407.25.661h2c0-.76-.284-1.456-.75-1.985zM12 20a1 1 0 0 1-.661-.25l-1.324 1.5c.529.466 1.225.75 1.985.75zm.661-.25A1 1 0 0 1 12 20v2c.76 0 1.456-.284 1.985-.75zm-8.322-7A1 1 0 0 1 4 12H2c0 .896.394 1.701 1.015 2.25zm8.454-8.366 7 7 1.414-1.414-7-7zm-1.409 15.409-7-7-1.414 1.414 7 7zm8.232-7-7 7 1.414 1.414 7-7zM7 8h.01V6H7z"
    })));
};

export { SvgTagOutline as ReactComponent };
//# sourceMappingURL=TagOutline.svg.es.js.map
